import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import {
    collection,
    query,
    where,
    getDocs,
    setDoc,
    doc
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Toast } from '../components_root/ToastContext';
import { MdOutlineVerifiedUser, MdCalendarMonth, MdClose, MdSensorWindow, MdLogin, MdNumbers } from "react-icons/md";
import "../body_root/popup.css";
import Ledger_accounts_full_profile from "../company_root/staff_account_root/ledger_accounts_full_profile";
import Ledger_accounts_profile from "../company_root/staff_account_root/ledger_accounts_profile";
import { Verify_stafftype_account } from "../company_root/staff_account_root/verify_stafftype_account";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

export default function Queue_verify({ data, isOpen, onClose }) {

    const [iunderstand, setIunderstand] = useState(false);
    const [queuecode, setQueuecode] = useState("");
    const [verify_note, setVerify_note] = useState(""); 
    const [queue_verification, setQueue_verification] = useState(false);
    const panelRef = useRef(null);
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    //staff account verify
    const [staffstatus, setStaffstatus] = useState(false);
    const [staffdata, setStaffdata] = useState([]);

    useEffect(() => {
        const verifyStaffAccount = async () => {
            const accountguid = Cookies.get("guid");
            const result = await Verify_stafftype_account(accountguid);
            if (result.success) {
                setQueue_verification(result.data.queue_verification);
                setStaffdata(result.data);
                setStaffstatus(true);
            }
        };
        verifyStaffAccount();
    }, []);

    useEffect(() => {
        const onDocClick = (e) => {
            if (isOpen && panelRef.current && !panelRef.current.contains(e.target)) {
                onClose?.();
            }
        };
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, [isOpen, onClose]);

    // useEffect(() => {
    //     if (!data) return;
    //     setAccount_type(data.account_type || "");
    //     setDescription(data.description || "");
    //     setaccountguid(data.filedid || "");

    // }, [data, isOpen]);

    const handleverify = async () => {
        const sessiontoken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");
        const select_company_uid = Cookies.get("select_company_uid");

        if (!sessiontoken) {
            Toastshow("Session expired. Please log in again.");
            return;
        }

        if (!guid) {
            Toastshow("Login expired. Please log in again.");
            return;
        }

        if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null") {
            Toastshow("Contact your service provider.");
            return;
        }

        if (staffdata.account_type == "admin") {
        } else {
            if (queue_verification ===false && data.guid === guid) {
                Toastshow("You are not authorized for verification.");
                return;
            }
        }

        if (!iunderstand) {
            Toastshow("Please confirm verification.");
            return;
        }
        if (!verify_note || !verify_note.trim()) {
            Toastshow("Please note verification.");
            return;
        }
        if (data.queue !== queuecode) {
            Toastshow("Please enter valid queue code");
            return;
        }

        if (!select_company_uid) return;
        //   const servicetablename = data.servicetablename;
        //   const tablename = data.tablename;
        const historyQuery = query(
            collection(db, "companies", select_company_uid, "log_history"),
            where("logid", "==", data.logid)
        );

        const snap = await getDocs(historyQuery);
        if (snap.empty) {
            Toastshow("Log history not found");
            return;
        }
        try {
            const parentDocRef = doc(
                db,
                data.servicetablename,
                select_company_uid,
                data.tablename,
                data.filedid
            );

            await Promise.all(
                Object.entries(data.dataupdates || {}).map(([key, value]) =>
                    setDoc(
                        parentDocRef,
                        { [key]: value, date_time_update: new Date(), queuecode: queuecode },
                        { merge: true }
                    )
                )
            );
            // All updates succeeded — now update log
            const docRef = snap.docs[0].ref;
            await setDoc(
                docRef,
                {
                    log_status: true,
                    verify_status: true,
                    verify_accountguid: guid,
                    verify_note: verify_note,
                    verify_sessiontoken: sessiontoken,
                    verify_date_time: new Date(),
                },
                { merge: true }
            );

            onClose?.();
            Toastshow("Verification completed.");
        } catch (error) {
            Toastshow("Update failed.");
            console.error(error);
        }

 
    };
    const handle_reject = async () => {
      if (staffdata.account_type == "admin") {
        } else {
            if (data.guid === guid) {
                Toastshow("You are not authorized for verification.");
                return;
            }
        }
        if (!iunderstand) {
            Toastshow("Please confirm verification.");
            return;
        }
        if (!verify_note || !verify_note.trim()) {
            Toastshow("Please note rejection.");
            return;
        }
        if (data.queue !== queuecode) {
            Toastshow("Please enter valid queue code");
            return;
        }
        const sessiontoken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");
        const select_company_uid = Cookies.get("select_company_uid");

        if (!select_company_uid) return;

        const historyQuery = query(
            collection(db, "companies", select_company_uid, "log_history"),
            where("logid", "==", data.logid)
        );

        const snap = await getDocs(historyQuery);

        if (snap.empty) {
            Toastshow("Log history not found");
            return;
        }
        try {
            const docRef = snap.docs[0].ref;

            await setDoc(docRef, {
                verify_note,
                log_status: true,
                verify_accountguid: guid,
                verify_sessiontoken: sessiontoken,
                verify_date_time: new Date(),
                verify_status: false,
            }, { merge: true });

            Toastshow("Rejected successfully.");
        } catch (e) {
            Toastshow("Failed to reject account.");
        }


        onClose?.();
    };
       useEffect(() => {
        if (!isOpen) return;

        const handleEsc = (e) => {
            if (e.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [isOpen, onClose]);
    return (
        <div className={`div-popup-body ${isOpen ? "show" : ""}`}>
            <div ref={panelRef} className={`overflow-auto div-panel-right ${isOpen ? "slide-in" : "slide-out"}`}>

                <div className="b-bottom items-back">
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="button-ui0 text-h2 bold p-2">
                                        <MdOutlineVerifiedUser className="icon" />
                                        Queue verification
                                    </div>
                                </td>
                                <td width={30}>
                                    <div
                                        onClick={() => onClose?.()}
                                        className="button-ui0 p-2 cursor"
                                    >
                                        <MdClose className="icon" />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="p-1">
                    {/* <Ledger_accounts_full_profile accountguid={data.filedid} /> */}

                    <div  >
                     
                        <Ledger_accounts_profile accountguid={data.guid} />
                           <div className="b-dot-2-red rounded m-1" >
                        <table>
                            <tbody>

                                <tr>
                                    <td><MdCalendarMonth className="icon" /></td>
                                    <td className="text-h3">
                                        {data?.date_time?.toDate ? (
                                            <>
                                                {data.date_time.toDate().toLocaleDateString()}{" "}
                                                {data.date_time.toDate().toLocaleTimeString()}
                                            </>
                                        ) : (
                                            <div className="contact-details">No date</div>
                                        )}
                                    </td>
                                    <td className="text-h2 fcap">{data?.history_type}</td>
                                </tr>

                            </tbody>
                        </table>
                        <table className="table_padding">
                            <tr className="b-bottom">
                                <th className="text-h2">Name</th>
                                <th className="text-h2">Changes</th>
                            </tr>
                            <tbody>

                                {Object.entries(data.dataupdates || {}).map(([key, value]) => (
                                    <tr key={key}>
                                        <td className="text-h3 text-off fcap">{key}</td>
                                        <td className="text-h3 bold fcap">{String(value)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {data.accountguid ? (
                            <Ledger_accounts_profile accountguid={data.accountguid} />
                        ) : ""}
                        </div>
                        {data.log_status == false ? (
                            <>
                                <table>
                                    <tbody>


                                        <tr>
                                            <td>
                                                <div className="button-ui2">{data.queue}</div>
                                            </td>
                                            <td>
                                                <input
                                                    value={queuecode}
                                                    onChange={(e) => setQueuecode(e.target.value)}
                                                    maxLength={6}
                                                    placeholder="Enter queue code"
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <div className="button-ui0">Note</div>
                                            </td>
                                            <td>
                                                <input
                                                    value={verify_note}
                                                    onChange={(e) => setVerify_note(e.target.value)}
                                                    maxLength={100}
                                                    placeholder="Enter note"
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td width={60}><div className="text-h3 text-off">Mark</div></td>
                                            <td>
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        checked={iunderstand}
                                                        onChange={(e) => setIunderstand(e.target.checked)}
                                                    />
                                                    <a className="text-h2">
                                                        I understand this queue.*
                                                    </a>
                                                </label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table>
                                    <tr>
                                        <td>
                                            <div
                                                className="button-ui p-2 fill text-h2 green-back cursor"
                                                onClick={handleverify}
                                            >
                                                Verify
                                            </div>
                                        </td>
                                        <td>
                                            <div
                                                className="button-ui p-2 fill text-h2 red-back cursor"
                                                onClick={handle_reject}
                                            >
                                                Reject
                                            </div>
                                        </td>
                                    </tr>

                                </table>

                            </>
                        ) : (

                            <>
                                <div
                                    className="b-top"

                                >

                                    <table>
                                        <tr>
                                            <tr>
                                                <td ><MdCalendarMonth className="icon" />  </td>
                                                <td><div className="text-h3 text-off">Verified</div></td>
                                                <td className="text-h3 bold">
                                                    {data?.verify_date_time?.toDate ? (
                                                        <>
                                                            {data.verify_date_time.toDate().toLocaleDateString()}{" "}
                                                            {data.verify_date_time.toDate().toLocaleTimeString()}
                                                        </>
                                                    ) : (
                                                        <div className="contact-details">No date</div>
                                                    )}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td><div className="text-h3 text-off">Note</div></td>
                                                <td><div className="text-h2">{data.verify_note || "N/A"}</div></td>
                                            </tr>
                                            <tr>
                                                <td ><MdNumbers className="icon" />  </td>
                                                <td><div className="text-h3 text-off">Log id</div></td>
                                                <td><div className="text-h3 bold">{data.logid}</div></td>
                                            </tr>
                                            <tr>
                                                <td ><MdNumbers className="icon" />  </td>
                                                <td><div className="text-h3 text-off">Queue</div></td>
                                                <td><div className="text-h3 bold">{data.queue}</div></td>
                                            </tr>
                                            <tr>
                                                <td ><MdLogin className="icon" />  </td>
                                                <td><div className="text-h3 text-off">Session</div></td>
                                                <td><div className="text-h3 bold">{data.verify_sessiontoken}</div></td>
                                            </tr>
                                        </tr>
                                    </table>
                                </div>
                                <Ledger_accounts_profile accountguid={data.verify_accountguid} />
                            </>
                        )}


                    </div>
                </div>
            </div>
        </div>
    );
}
